import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiArrowUp } from 'react-icons/fi';

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldHide, setShouldHide] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollPosition = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show scroll to top after scrolling down 300px
      setIsVisible(scrollPosition > 300);
      
      // Hide when near bottom on mobile to avoid footer content collision
      const isMobileView = window.innerWidth < 768;
      const nearBottom = scrollPosition + windowHeight > documentHeight - 200;
      setIsMobile(isMobileView);
      setShouldHide(isMobileView && nearBottom);
    };

    window.addEventListener('scroll', toggleVisibility);
    window.addEventListener('resize', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      window.removeEventListener('resize', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {isVisible && !shouldHide && (
        <motion.button
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={scrollToTop}
          className={`
            fixed bottom-4 left-4 md:bottom-8 md:left-8 z-40 
            ${isMobile 
              ? 'w-8 h-8 bg-white/20 dark:bg-black/40 backdrop-blur-md hover:bg-white/30 dark:hover:bg-black/60 border border-white/30 dark:border-gray-600/30' 
              : 'w-12 h-12 bg-primary-600 hover:bg-primary-700'
            } 
            text-white rounded-full shadow-lg hover:shadow-xl 
            transition-all duration-200 flex items-center justify-center 
            focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
            ${!isMobile ? 'border-0' : ''} outline-none
          `}
          style={!isMobile ? { 
            filter: 'drop-shadow(0 4px 12px rgba(59, 130, 246, 0.3))'
          } : {}}
          aria-label="Scroll to top"
        >
          {isMobile ? (
            // Pure chevron icon - minimal and clean
            <svg 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              className="text-white"
            >
              <polyline points="18,15 12,9 6,15"></polyline>
            </svg>
          ) : (
            <FiArrowUp size={20} />
          )}
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;